var Handlebars = require("/home/travis/build/OpenBudget/open-budget-api/webapp/open-budget/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(__default(require("/home/travis/build/OpenBudget/open-budget-api/webapp/open-budget/app/scripts/Hasadna/oBudget/Misc/handlebarsHelpers/format_full_number.coffee")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.total : depth0),{"name":"format_full_number","hash":{},"data":data}))
    + " ₪";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"bubble-group-label\">\n  <div class=\"bubble-group-label-child bubble-group-label-total-sum\">\n  	"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.total : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n  </div>\n  <div class=\"bubble-group-label-child bubble-group-label-title\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.title : depth0), depth0))
    + "</div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/templates/bubble-group-label.hbs
// module id = 113
// module chunks = 0